<template>
  <div class="MasterclassShop" v-if="masterclass">
    <simple-header
      :label="$t('global.back')"
      @click="$router.back()"
    />
    <vv-hero :title="masterclass.title" height="400" :backgroundPositionY="['mobile', 'tablet'].includes($mq) ? '0' : '-500'" :asset="masterclass.tileImage" v-on:scrollView="scrollViewTo" scrollTo="offers" />

    <!-- Author block -->
    <div :class="{ Author: true, 'Author--small': $mq === 'mobile' }" v-if="masterclass.author.present">
      <img :alt="authorIdentity" :src="authorPortrait" class="Portrait" v-if="!isUnavailable" />

      <div class="Informations">
        <div class="Head">
          <span class="Identity" v-if="!isUnavailable">
            {{ t('authorPrefix') }} <strong>{{ authorIdentity }}</strong>
          </span>
          {{ authorTitle }}
        </div>

        <span class="Description" v-if="!isUnavailable">
          <vv-rich-text :document="authorDescription" />
        </span>
      </div>
    </div>

    <div class="Separator Separator-Bas" id="offers" v-if="shopifyProducts.length > 0">
      <img src="@/assets/papier-dechire-bas.png" />
    </div>

    <div :class="{ Offers: true, 'Offers--small': $mq === 'mobile' }" v-if="shopifyProducts.length > 0">
      <mq-layout :mq="['mobile', 'tablet']" class="mq-title title-mobile">
        <vv-section-title-mobile class="SectionTitle">{{ t('ourOffers') }}</vv-section-title-mobile>
      </mq-layout>
      <mq-layout :mq="['desktop']" class="mq-title title-no-mobile">
        <vv-section-title class="SectionTitle">{{ t('ourOffers') }}</vv-section-title>
      </mq-layout>
      <div class="SectionSubTitle">{{ t('offersSubtitle', { name: masterclass.title }) }}</div>
      <div class="MasterclassOffers">
        <masterclass-offer
          v-for="(product, index) in shopifyProducts"
          :key="`masterclass-${product.id}`"
          :shopifyMasterclass="product"
          :index="index"
          @click="onBuy"
          @propagate-show-modal="showOfferModal(index)"
        />
      </div>
    </div>

    <div class="Separator Separator-Haut" v-if="shopifyProducts.length > 0">
      <img src="@/assets/papier-dechire-haut.png" />
    </div>

    <div :class="{ Teaser: true, 'Teaser--small': $mq === 'mobile' }">
      <mq-layout :mq="['mobile', 'tablet']" class="mq-title title-mobile">
        <vv-section-title-mobile class="SectionTitle--solo">{{ masterclass.title }}</vv-section-title-mobile>
      </mq-layout>
      <mq-layout :mq="['desktop']" class="mq-title title-no-mobile">
        <vv-section-title class="SectionTitle--solo">{{ masterclass.title }}</vv-section-title>
      </mq-layout>
      <div class="Description" v-if="masterclassDescription">
        <vv-rich-text :document="masterclassDescription" />
      </div>

      <div :class="{ LessonSteps: true, 'LessonSteps--small': $mq === 'mobile' }">
        <div class="LessonStep" v-for="lessonStepId in lessonStepIds" :key="lessonStepId">
          <lesson-step-content-tile :lesson-step-id="lessonStepId" />
        </div>
      </div>
    </div>

    <modal name="offer-masterclass-modal" :adaptive="true" :reset="true" :class="{OfferMasterclassModal: true, 'OfferMasterclassModal--small': $mq === 'mobile'}">
      <modal-gift :masterclass="masterclass" @propagate-close-modal="closeOfferModal" @propagate-validate-gift="validateOfferGift"></modal-gift>
    </modal>

  </div>
</template>

<script>
import _get from 'lodash/get'

import shop from '@/mixins/shop'

import { VvHero, VvSectionTitle, VvSectionTitleMobile } from '@/components/common'

import VvRichText from '@/components/common/VvRichText'
import LessonStepContentTile from '@/components/lesson/LessonStepContentTile'
import MasterclassOffer from '@/components/shop/MasterclassOffer'
import SimpleHeader from '@/components/navigation/SimpleHeader'

import ModalGift from '@/components/shop/ModalGift'

export default {
  name: 'MasterclassShop',
  components: { VvRichText, VvHero, VvSectionTitle, VvSectionTitleMobile, LessonStepContentTile, MasterclassOffer, SimpleHeader, ModalGift },
  mixins: [shop],
  props: {
    masterclassId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      masterclassType: 0,
      index: 0
    }
  },
  computed: {
    masterclass() {
      return this.$store.getters.getThemeById(this.masterclassId)
    },
    authorIdentity() {
      return this.masterclass.author.fullName
    },
    authorPortrait() {
      return this.masterclass.author.image
    },
    authorTitle() {
      return this.masterclass.author.job
    },
    authorDescription() {
      return this.masterclass.author.description
    },
    isUnavailable() {
      return this.masterclass.author && this.masterclass.author.fullName === 'PENDING' ? true : false
    },
    masterclassDescription() {
      return this.masterclass.shopDescription
    },
    lessonStepIds() {
      return this.masterclass.lessonSteps.map(el => el.id)
    },
    shopifyProducts() {
      return this.masterclass.shopifyIds
        .map(shopifyId => this.$store.state.shop.masterclasses.find(masterclass => masterclass.id === shopifyId))
        .sort((a, b) => Number(a.variants[0].price) - Number(b.variants[0].price))
    }
  },
  methods: {
    t(key, params) {
      return this.$t(`shop.lesson-details.${key}`, params)
    },
    onBuy(offerIndex) {
      const product = this.shopifyProducts[offerIndex]
      let type = offerIndex === 0 ? 1 : 2
      this.addToCart(product.variants[0].id, 1, type)
    },
    scrollViewTo(scrollTo) {
      const yourElement = document.getElementById(scrollTo);
      const y = yourElement.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({top: y, behavior: 'smooth'});
    },
    showOfferModal(index) {
      this.index = index
      this.masterclassType = index === 0 ? 1 : 2
      this.$modal.show('offer-masterclass-modal');
    },
    closeOfferModal() {
      this.masterclassType = 0
      this.$modal.hide('offer-masterclass-modal');
    },
    validateOfferGift(value) {
      if (value && value.lastnameGift && value.firstnameGift && value.emailGift) {
        // Add to cart with the variantId, quantity = 0, type (1 for masterclass only) and emailGift
        this.addToCart(this.shopifyProducts[this.index].variants[0].id, 1, this.masterclassType, {
          lastname: value.lastnameGift,
          firstname: value.firstnameGift,
          email: value.emailGift
        })
        this.masterclassType = 0
        this.index = 0
        this.$modal.hide('offer-masterclass-modal');
      } else {
        console.log('error no value for modal offer gift')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.OfferMasterclassModal {
  /deep/ .v--modal {
    margin-left: auto !important;
    margin-right: auto !important;
    left: 0 !important;
    right: 0!important;
    height: 575px !important;
    top: 100px !important;
  }
}

.OfferMasterclassModal--small {
  /deep/ .v--modal {
    width: 90% !important;
    height: 575px !important;
    margin-left: auto !important;
    margin-right: auto !important;
    left: 0 !important;
    right: 0!important;
    top: 25px !important;
  }
}

.simple-header {
  margin-left: 10px;
}

.MasterclassShop {
  padding-bottom: 10px;

  .Separator {
    width: 100%;
    
    img {
      height: 50px;
      width: 100%;
    }
  }

  .Author {
    margin-top: 80px;
    margin-left: 65px;
    margin-right: 65px;
    text-align: center;

    .Portrait {
      width: 250px;
      margin-right: 30px;
    }

    .Informations {
      display: inline-block;
      vertical-align: top;
      width: 45%;
      text-align: left;

      .Head {
        border-bottom: 2px solid $primary;
        padding-bottom: 15px;
        margin-bottom: 25px;

        .Identity {
          color: $primary;
          padding-right: 4px;
          margin-right: 4px;
          border-right: 1px solid black;
        }
      }

      .Description {
        line-height: 21px;
        font-size: smaller;
      }
    }

    &--small {
      margin-top: 40px;

      .Portrait {
        margin-right: 0;
        max-width: 90%;
      }

      .Informations {
        margin-top: 20px;
        width: 90%;
      }
    }
  }

  .Offers {
    text-align: center;

    .MasterclassOffer:not(:last-of-type) {
      margin-right: 40px;
    }


    .MasterclassOffers {
      margin-top: 100px;
      display: inline-flex;
      justify-content: space-around;
    }

    &--small {
      .MasterclassOffer:not(:last-of-type) {
        margin-right: 0px;
      }

      .MasterclassOffers {
        flex-direction: column;
        margin-top: 30px;
      }

      .SectionSubTitle {
        font-size: 15px;
      }
    }
  }

  .Teaser {
    margin-top: 30px;
    text-align: center;
    margin-left: 10%;
    margin-right: 10%;

    .Description {
      text-align: left;
      display: inline-block;
      width: 60%;
    }

    &--small {
      .Description {
        width: 90%;
        font-size: 26%;
      }
    }
  }

  .LessonSteps {
    text-align: left;
    margin-top: 40px;

    .LessonStep {
      display: inline-block;
      width: 33%;
      padding: 0 20px 15px 20px;
      box-sizing: border-box;
    }

    &--small {
      .LessonStep {
        width: 50%;
        padding: 0 10px 5px 10px;
      }
    }
  }

  .SectionTitle {
    margin-top: 50px;

    &--solo {
      margin-bottom: 30px;
    }
  }

  .SectionSubTitle {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 30px;
    font-weight: bold;
    font-family: Caveat;
    font-size: 32px;
  }
}

</style>
